import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeofenceService } from '@app-asset-config/services/geofence.service';
import { GeofenceFilterSelectComponent } from '../geofence-filter-select/geofence-filter-select.component';
import { DataService } from '@app-core/services/data/data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-geofence-filter-list',
  templateUrl: './geofence-filter-list.component.html',
  styleUrls: ['./geofence-filter-list.component.scss'],
})
export class GeofenceFilterListComponent implements OnInit {
  @Input() public filterFor: 'geofence' | 'activity' = 'geofence';
  @Input() appliedFilter: any = {};

  @Output() selected = new EventEmitter();

  public currentFilterState = {
    propertyIds: [],
    tagIds: [],
    geofenceIds: [],
    geofenceActivities: [],
  };

  public showResetButton = false;

  public NONE: string = this.translateService.instant('geofenceNone');
  public APPLIED: string = ' ' + this.translateService.instant('geofenceApplied');

  constructor(private geofenceService: GeofenceService, public dataService: DataService, private translateService: TranslateService) {}

  ngOnInit(): void {
    this.currentFilterState = { ...this.appliedFilter };

    this.showResetButton = this.canShowResetButton();
  }

  goBack() {
    this.geofenceService.pop();
  }

  navigateToFilterSelection(filterType: string) {
    this.geofenceService.navigateTo(GeofenceFilterSelectComponent, {
      filterType: filterType,
      preSelect: this.currentFilterState[filterType],
      'output:selected': (data) => {
        const keyname = Object.keys(data)[0];
        this.currentFilterState[keyname] = data[keyname];

        this.showResetButton = this.canShowResetButton();

        this.selected.emit(data);
      },
    });
  }

  resetFilters() {
    this.currentFilterState = {
      propertyIds: [],
      tagIds: [],
      geofenceIds: [],
      geofenceActivities: [],
    };
    this.selected.emit(this.currentFilterState);
    this.showResetButton = this.canShowResetButton();
  }

  canShowResetButton(): boolean {
    return (
      this.currentFilterState.propertyIds.length > 0 ||
      this.currentFilterState.tagIds.length > 0 ||
      this.currentFilterState.geofenceIds.length > 0 ||
      this.currentFilterState.geofenceActivities.length > 0
    );
  }
}
